"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageListToJSON = exports.ImageListFromJSONTyped = exports.ImageListFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ImageListFromJSON(json) {
    return ImageListFromJSONTyped(json, false);
}
exports.ImageListFromJSON = ImageListFromJSON;
function ImageListFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : (json['data'].map(_1.ImageListDataFromJSON)),
    };
}
exports.ImageListFromJSONTyped = ImageListFromJSONTyped;
function ImageListToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': value.data === undefined ? undefined : (value.data.map(_1.ImageListDataToJSON)),
    };
}
exports.ImageListToJSON = ImageListToJSON;
//# sourceMappingURL=ImageList.js.map